import config from "@/data/config";

const app = {
  state: {
    questionData: [],
    answerData: [],
    recommendationData: [],
    currentQuestion: null,
    surveyAnswers: [],
    surveyComplete: false,
    sessionId: null,
    adminAnalytics: []
  },
  mutations: {
    SET_ADMIN_ANALYTICS(state, value) {
      state.adminAnalytics = value;
    },
    SET_SESSION_ID(state, value) {
      state.sessionId = value;
    },
    SET_QUESTION_DATA(state, value) {
      state.questionData = value;
    },
    SET_ANSWER_DATA(state, value) {
      state.answerData = value;
    },
    SET_RECOMMENDATIONS_DATA(state, value) {
      state.recommendationData = value;
    },
    SET_CURRENT_QUESTION(state, value) {
      state.currentQuestion = value;
    },
    ADD_SURVEY_ANSWER(state, value) {
      state.surveyAnswers.push(value);
    },
    UPDATE_SURVEY_ANSWER(state, { index, newAnswer }) {
      state.surveyAnswers.splice(index, 1, newAnswer);
    },
    SET_SURVEY_COMPLETE(state, value) {
      state.surveyComplete = value;
    },
    DELETE_SURVEY_QUESTION(state, value) {
      state.questionData = state.questionData.filter(
        (questionData) => questionData.uuid !== value
      );
    },
    ADD_SURVEY_QUESTION(state, value) {
      state.questionData.push(value);
    },
    UPDATE_SURVEY_QUESTION(state, value) {
      state.questionData.splice(value.index, 1, value.questionText);
    }
  },
  actions: {
    async fetchQuestionData({ commit }) {
      try {
        const url = config.url.GOOGLE_SHEET_1_URL;
        const response = await fetch(url);
        const rawData = await response.text();

        const regexMatch = rawData.match(
          /google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/
        );

        if (regexMatch && regexMatch.length === 2) {
          const parsedData = JSON.parse(regexMatch[1]);
          const tableData = parsedData.table;
          const formattedRows = tableData.rows.map(({ c }) =>
            c.map((cell) => (cell ? cell.v || "" : ""))
          );
          const theData = formattedRows.map((row, index) => {
            let datum = {
              index: index,
              topic: row[0],
              questionText: row[1],
              questionId: row[2],
              uuid: row[3]
            };
            return datum;
          });

          // console.log(theData);
          commit("SET_QUESTION_DATA", [...theData]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAnswerData({ commit }) {
      try {
        const url = config.url.GOOGLE_SHEET_3_URL;
        const response = await fetch(url);
        const rawData = await response.text();

        const regexMatch = rawData.match(
          /google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/
        );

        if (regexMatch && regexMatch.length === 2) {
          const parsedData = JSON.parse(regexMatch[1]);
          const tableData = parsedData.table;
          const formattedRows = tableData.rows.map(({ c }) =>
            c.map((cell) => (cell ? cell.v || "" : ""))
          );
          const theData = formattedRows.map((row, index) => {
            let datum = {
              index: index,
              id: row[0],
              label: row[1]
            };
            return datum;
          });
          console.log(theData);
          commit("SET_ANSWER_DATA", [...theData]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchRecommendationData({ commit }) {
      try {
        const url = config.url.GOOGLE_SHEET_2_URL;
        const response = await fetch(url);
        const rawData = await response.text();

        const regexMatch = rawData.match(
          /google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/
        );

        if (regexMatch && regexMatch.length === 2) {
          const parsedData = JSON.parse(regexMatch[1]);
          const tableData = parsedData.table;
          const formattedRows = tableData.rows.map(({ c }) =>
            c.map((cell) => (cell ? cell.v || "" : ""))
          );
          const theData = formattedRows.map((row, index) => {
            return {
              index: index,
              questionUUID: row[0],
              opportunityForImprovementText: row[1],
              opportunityForImprovementUrl: row[2],
              opportunityForImprovementId: row[3]
            };
          });

          commit("SET_RECOMMENDATIONS_DATA", [...theData]);
        } else {
          console.error("Unexpected response format:", rawData);
        }
      } catch (error) {
        console.error("Error fetching recommendation data:", error);
      }
    },
    setQuestionData({ commit }, value) {
      commit("SET_QUESTION_DATA", value);
    },
    setRecommendationData({ commit }, value) {
      commit("SET_RECOMMENDATIONS_DATA", value);
    },
    setCurrentQuestion({ commit }, value) {
      commit("SET_CURRENT_QUESTION", value);
    },
    addSurveyAnswer({ commit }, value) {
      commit("ADD_SURVEY_ANSWER", value);
    },
    setSurveyComplete({ commit }, value) {
      commit("SET_SURVEY_COMPLETE", value);
    },
    updateSurveyAnswer({ commit }, value) {
      commit("UPDATE_SURVEY_ANSWER", value);
    },
    setSessionId({ commit }, value) {
      commit("SET_SESSION_ID", value);
    },
    setAdminAnalytics({ commit }, value) {
      commit("SET_ADMIN_ANALYTICS", value);
    },
    mapFromDatastore({ commit, state }, payload) {
      let _payload = "";
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        _payload = payload;
      }
      console.log(commit, state, payload, _payload);
      /*
       * Call a mutation to put your datastore payload into your app state
       */
    }
  },
  getters: {
    getAdminAnalytics(state) {
      return state.adminAnalytics;
    },
    getQuestionData(state) {
      return state.questionData;
    },
    getAnswerData(state) {
      return state.answerData;
    },
    getRecommendationData(state) {
      return state.recommendationData;
    },
    getCurrentQuestion(state) {
      return state.currentQuestion;
    },
    getSurveyAnswers(state) {
      return state.surveyAnswers;
    },
    getSurveyComplete(state) {
      return state.surveyComplete;
    },
    getSessionId(state) {
      return state.sessionId;
    },
    mapToDatastore(state) {
      // let payload = { ...state };
      // payload = JSON.stringify(payload);
      // return payload;
      console.log("Not using datastore", state);
    }
  }
};

export default app;
